import { SituationReason } from '../controllers/approval-list/approval-list-controller';

export interface Approval {
  id: number
  processId: number
  situation: string
  releaseDate: string
  orderType: string,
  purchaseRequestNumber: number | string,
  documentNumber: number,
  totalApprovalValue: number,
  originStock: string,
  targetStock: string,
  usernameOpinion: string,
  observation: string,
  reason: SituationReason
}

export default class ApprovalContext {
  private static approval: Approval;

  public static get(): Approval {
    return this.approval;
  }

  public static set(approval: Approval): void {
    this.approval = approval;
  }
}
